import classNames from "classnames";
import { JSX, PropsWithoutRef } from "react";

export type SectionTagProps = PropsWithoutRef<JSX.IntrinsicElements["h2"]>;

export default function SectionTag({ children, className, ...props }: SectionTagProps) {
  return (
    <h4 {...props} className={classNames("text-primary", className)}>{children}</h4>
  );
}
